/*=========================================================================================
  File Name: moduleCalendarMutations.js
  Description: Calendar Module Mutations
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import axios from '@/axios.js';

export default {
  SET_LOGGEDIN_STATE (state, value) {
    state.isUserLoggedIn = value;
  },
  SET_USER (state, value) {
    state.user = value
  },
  SET_ACCESS_TOKEN (state, value) {
    state.accessToken = value
  },
  REMOVE_RECORD (state, itemId) {
    const userIndex = state.users.findIndex((u) => u.id === itemId)
    state.users.splice(userIndex, 1)
  },
  SET_BEARER (state, accessToken) {
    axios.defaults.headers.common['Authorization'] = `Bearer ${accessToken}`
  },
  SET_OTP_STATUS(state, value) {
    state.otpSent = value
  }
}
